export enum TemperatureUnitsExtension {
  CELSIUS_DEGREE = '°C',
  DEGREE_CELSIUS = 'C°',
}
